import { render, staticRenderFns } from "./WarehouseTransferCreatePage.vue?vue&type=template&id=45ff2ff8&"
import script from "./WarehouseTransferCreatePage.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransferCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ff2ff8')) {
      api.createRecord('45ff2ff8', component.options)
    } else {
      api.reload('45ff2ff8', component.options)
    }
    module.hot.accept("./WarehouseTransferCreatePage.vue?vue&type=template&id=45ff2ff8&", function () {
      api.rerender('45ff2ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/warehouse-transfer/WarehouseTransferCreatePage.vue"
export default component.exports